import {
  HHBox,
  HHStack,
  HHTypography,
} from '@hinge-health/react-component-library';
import { ReactNode } from 'react';

export const PAGE_HEADER_TEST_ID = 'pdg-page-header';

interface PageHeaderProps {
  title: string;
  subtitle?: ReactNode;
  /** Buttons rendered on the right, top-aligned with the title. */
  actions?: ReactNode;
}

/**
 * Page title block per the v4 spec type scale: 24/600 title with tightened
 * tracking, muted one-line subtitle, actions on the right.
 */
export const PageHeader = ({
  title,
  subtitle,
  actions,
}: PageHeaderProps): JSX.Element => (
  <HHStack
    direction="row"
    justifyContent="space-between"
    alignItems="flex-start"
    gap={6}
    data-testid={PAGE_HEADER_TEST_ID}
  >
    <HHStack gap={1}>
      <HHTypography
        hhVariant="variant-bypass"
        variant="h4"
        component="h1"
        sx={{
          fontSize: 24,
          fontWeight: 600,
          letterSpacing: '-0.015em',
          lineHeight: 1.2,
        }}
      >
        {title}
      </HHTypography>
      {subtitle &&
        (typeof subtitle === 'string' ? (
          <HHTypography
            hhVariant="variant-bypass"
            variant="body1"
            color="text.secondary"
          >
            {subtitle}
          </HHTypography>
        ) : (
          subtitle
        ))}
    </HHStack>
    {actions && (
      <HHBox flexShrink={0} paddingTop={0.75}>
        {actions}
      </HHBox>
    )}
  </HHStack>
);
